var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shop-new.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-157a0538!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shop-new.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShopNew.vue
// module id = 708
// module chunks = 1